/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';

// Component imports
import { FilterIcon } from '../../../components/Icons/FilterIcon';

// Misc imports
import useTheme from '../useTheme';

const useTableFilterIcon = filtered => {
  const { primaryColor } = useTheme();

  return (
    <FilterIcon style={{ color: filtered ? primaryColor : 'inherit' }} />
  );
};

export default useTableFilterIcon;
